// extracted by mini-css-extract-plugin
export default {"container":"ArticlePreview_container__bIDGB"};